<template>
  <div class="submit-form form-container">
    <h3>Amount</h3>

    <div class="amount-table">
      <div class="amount-table__row">
        <div class="amount-table__data amount-table__data--title">
          Total Amount Due
        </div>
        <div class="amount-table__data amount-table__data--value amount-table__data--bold">
          {{ total }}
        </div>
      </div>
      <div class="amount-table__row">
        <div class="amount-table__data amount-table__data--title">
          Minimum Payment Today
        </div>
        <div class="amount-table__data amount-table__data--value amount-table__data--bold">
          {{ dueToday }}
        </div>
      </div>
      <div class="amount-table__row">
        <div class="amount-table__data amount-table__data--title">
          <p>Balance</p>
          <p class="amount-table__data--date">(Due: {{new Date().toLocaleDateString("en-US")}})</p>
        </div>
        <div class="amount-table__data amount-table__data--value amount-table__data--bold">
          {{ dueToday }}
        </div>
      </div>
    </div>

    <input
      class="btn"
      type="submit"
      :value="bookingText()"
      @click.prevent="validateForm"
      :disabled="submitting()"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      valid: true
    }
  },
  computed: {
    ...mapGetters([
      'total',
      'dueToday',
      'deposit'
    ])
  },
  methods: {
    validateForm() {
      this.$emit('validate')
    },
    bookingText() {
      return this.submitting() ? 'Submitting' : 'Confirm Booking'
    },
    submitting() {
      return this.$store.state.checkoutSubmitting
    }
  }
}
</script>

<style>
  .submit-form {
    margin: 20px 0;
    .amount-table {
      margin: 25px 0 45px 0;
      &__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        &:nth-child(odd) {
          background: #f4f4f4;
        }
      }

      &__data {
        font-size: 16px;
        line-height: 1.38;
        letter-spacing: 0.25px;
        padding: 14px 10px;

        &--title {
          color: $gray;
        }

        &--date {
          font-size: 12px;
        }

        &--bold {
          font-weight: 800;
        }

        &--value {
          text-align: right;
          color: $blueWhale;
        }
      }
    }

    .btn {
      background: $pumpkin;
      width: 100%;

      &[disabled] {
        background: $background;
        cursor: not-allowed;
      }
    }
  }
</style>
